import {
    SetErrorHandlerReturn,
    SetSystemLoadingReturn,
    ShowMessageReturn,
    ShowSystemErrorReturn,
} from 'store/actions/errorsActions';

export interface ErrorState {
    applicationError: boolean;
    serverError: boolean;
    forbiddenError: boolean;
    networkError: boolean;
    applicationLoading: boolean;
}

const initialState: ErrorState = {
    applicationError: false,
    serverError: false,
    forbiddenError: false,
    networkError: false,
    applicationLoading: false,
};

type ErrorActions = ShowMessageReturn | ShowSystemErrorReturn | SetErrorHandlerReturn | SetSystemLoadingReturn;

export const errorsReducer = (state: ErrorState = initialState, action: ErrorActions): ErrorState => {
    switch (action.type) {
        case 'MESSAGE_HANDLER':
            // @ts-ignore
            switch (action.payload.messageType) {
                case 'SUCCESS':
                    // @ts-ignore
                    window.toast.success(action.payload.message, action.payload.options || {});
                    break;
                case 'ERROR':
                    // @ts-ignore
                    window.toast.error(action.payload.message, action.payload.options || {});
                    break;
                case 'WARN':
                    // @ts-ignore
                    window.toast.warn(action.payload.message, action.payload.options || {});
                    break;
                case 'INFO':
                    // @ts-ignore
                    window.toast.info(action.payload.message, action.payload.options || {});
                    break;
                case 'CLOSE':
                    // @ts-ignore
                    window.toast.dismiss();
                    break;
                default:
                    break;
            }
            break;
        case 'SHOW_SYSTEM_ERROR':
            // @ts-ignore
            return { ...state, serverError: false, applicationError: true, applicationLoading: false };
        case 'SET_SYSTEM_LOADING':
            // @ts-ignore
            return { ...state, applicationLoading: action.payload };
        case 'ERROR_HANDLER':
            console.log(action);
            // @ts-ignore
            switch (action.payload?.response?.status || action.payload?.code || 900) {
                case 100:
                    return { ...state, serverError: false, applicationError: false };
                case 401:
                    localStorage.removeItem('token');
                    localStorage.removeItem('port');
                    localStorage.removeItem('user');
                    localStorage.removeItem('uuid');
                    /* @ts-ignore */
                    window.location = '/home';
                    return { ...state, applicationLoading: false };
                case 404:
                    return { ...state, applicationError: true };
                case 403:
                    return { ...state, forbiddenError: true };
                case 500:
                    return { ...state, serverError: !state.serverError };
                case 400:
                    // @ts-ignore
                    switch (action.payload.response.data.errors.messageType) {
                        case 'SUCCESS':
                            // @ts-ignore
                            window.toast.success(action.payload.response.data.message, { duration: 4000 });
                            break;
                        case 'ERROR':
                            // @ts-ignore
                            window.toast.error(action.payload.response.data.errors[0], { duration: 4000 });
                            break;
                        case 'WARN':
                            // @ts-ignore
                            window.toast.warn(action.payload.response.data.errors[0], { duration: 4000 });
                            break;
                        case 'INFO':
                            // @ts-ignore
                            window.toast.info(action.payload.data.errors[0], { duration: 4000 });
                            break;
                        default:
                            // @ts-ignore
                            window.toast.error(action.payload.response.data.errors[0], { duration: 4000 });
                            break;
                    }
                    break;
                case 900:
                case 'ERR_NETWORK':
                    return { ...state, networkError: !state.networkError };
                case null:
                    return { ...state, serverError: false };
                default:
                    return state;
            }
            break;
        default:
            return state;
    }
    return state;
};
